import age from '@/filters/age.js'
import capitalize from '@/filters/capitalize.js'
import cleanHtmlTags from '@/filters/cleanHtmlTags.js'
import date from '@/filters/date.js'
import datetime from '@/filters/datetime.js'
import first from '@/filters/first.js'
import globalNumber from '@/filters/globalNumber.js'
import humanReadable from '@/filters/humanReadable.js'
import isEmpty from '@/filters/isEmpty.js'
import isNotExpired from '@/filters/isNotExpired.js'
import maskString from '@/filters/maskString.js'
import number from '@/filters/number.js'
import percent from '@/filters/percent.js'
import phone from '@/filters/phone.js'
import phoneFormat from '@/filters/phoneFormat.js'
import substring from '@/filters/substring.js'
import truncate from '@/filters/truncate.js'

export const filters = {
  age,
  capitalize,
  date,
  cleanHtmlTags,
  datetime,
  first,
  globalNumber,
  humanReadable,
  isEmpty,
  isNotExpired,
  number,
  percent,
  phone,
  phoneFormat,
  substring,
  truncate,
  maskString
}
